import React from 'react';
import { Select } from 'antd';

export default function ReusableCountrySelect({ countries, ...props }) {
  return (
    <span>
      <Select
        {...props}
        notFoundContent="Not Found"
        filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
        {countries
          .filter((c) => c.emoji)
          .map((c, index) => (
            <Select.Option value={c.name + c.alpha2} key={index}>
              <div className="search-country-icon-and-name-wrapper">
                <span>{c.emoji}</span>
                <p>{c.name}</p>
              </div>
            </Select.Option>
          ))}
      </Select>
    </span>
  );
}
